export const images = {
    sliderImage1: require("../assets/images/SliderImage1.png"),
    sliderImage2: require("../assets/images/SliderImage2.png"),
    sliderImage3: require("../assets/images/SliderImage3.png"),
    logo: require("../assets/images/logo.png"),
    viewIcon: require("../assets/images/EyeIcon.png"),
    eyecloseIcon: require("../assets/images/EyecloseIcon.png"),
    profileImage: require("../assets/images/user_male_icon.png"),
    expandScreen: require("../assets/images/expandScreen.png"),
    minimseScreen: require("../assets/images/Minimize-screen.png"),
    alarm: require("../assets/images/alarm.png"),
    filter: require("../assets/images/filter.png"),
    greenMark: require("../assets/images/green-point.png"),
    redMark: require("../assets/images/red-point.png"),
    distributionIcon: require("../assets/images/distribution.png"),
    factoryIcon: require("../assets/images/factory.png"),
    redPipeBackground: require("../assets/images/red-pipe-background.png"),
    greenPipeBackground: require("../assets/images/green-pipe-background.png"),
    yellowPipeBackground: require("../assets/images/yellow-pipe-background.png"),
    redirectIcon: require("../assets/images/redirect-icon.png"),
    androidIcon: require("../assets/images/android.png"),
    iosIcon: require("../assets/images/apple.png"),
    excelIcon: require("../assets/images/excelIcon.png"),
    previousArrowIcon: require("../assets/images/previous-arrow-icon.png"),
    nextArrowIcon: require("../assets/images/next-arrow-icon.png"),
    blubIcon: require("../assets/images/bulb-icon.png"),
    leftArrowIcon: require("../assets/images/left-arrow.png"),
    rightArrowIcon: require("../assets/images/right-arrow.png"),
    blackPipeBackgound: require("../assets/images/black-pipe-background.png"),
    pieChartBgImg: require("../assets/images/piechartBGImg.png"),
    barChartBgImg: require("../assets/images/barchartBGImg.png"),
    pieChart: require("../assets/images/piechart.png"),
    barChart: require("../assets/images/barchart.png"),
    calendarIcon: require("../assets/images/Calender.png"),
    noDataFoundImg: require("../assets/images/notfound.png"),
    passwordImg: require("../assets/images/PasswordImg.png"),
    closeIcon: require("../assets/images/close.png"),
    editIcon: require("../assets/images/EditIcon.png"),
    communicationImg: require("../assets/images/ComminicationImg.png"),
    communicationDark: require("../assets/images/communication_light.png"),
    securityLight: require("../assets/images/security_light.png"),
    securityDark: require("../assets/images/security_dark.png"),
    userLight: require("../assets/images/user_light.png"),
    userDark: require("../assets/images/user_dark.png"),
    distributor1: require("../assets/images/distribution1.png"),
    plants: require("../assets/images/factory1.png"),
    mapFactoryIcon: require("../assets/images/map_factory.png"),
    mapDistributorIcon: require("../assets/images/map_distributor.png"),
    orageIcon : require("../assets/images/orange-icon.png"),
    resizeButton: require("../assets/images/resize-button (1).png"),
    resizeButton1: require("../assets/images/resize-button (2).png"),
}